import {  t  } from "@/client/libs/dummy-i18n";
import { 
  FileTextIcon, 
  GearIcon, 
  PaletteIcon, 
  ShareNetworkIcon 
} from "@phosphor-icons/react";
import { ScrollArea, Separator, Tabs, TabsContent, TabsList, TabsTrigger } from "@stackmorph/ui";
import { useState } from "react";

import { Copyright } from "@/client/components/copyright";
import { ThemeSwitch } from "@/client/components/theme-switch";

import { CssSection } from "./sections/css";
import { ExportSection } from "./sections/export";
import { InformationSection } from "./sections/information";
import { LayoutSection } from "./sections/layout";
import { NotesSection } from "./sections/notes";
import { PageSection } from "./sections/page";
import { SharingSection } from "./sections/sharing";
import { StatisticsSection } from "./sections/statistics";
import { TemplateSection } from "./sections/template";
import { ThemeSection } from "./sections/theme";
import { TypographySection } from "./sections/typography";
import { VersionHistory } from "./sections/version-history";

export const RightSidebar = () => {
  const [activeTab, setActiveTab] = useState("design");

  return (
    <div className="flex h-full flex-col bg-secondary-accent/30">
      <Tabs value={activeTab} className="flex h-full flex-col" onValueChange={setActiveTab}>
        <div className="border-b border-border/50 bg-background/80 px-4 py-2 backdrop-blur-md">
          <TabsList className="w-full">
            <TabsTrigger value="design" className="flex-1 gap-2">
              <PaletteIcon />
              <span className="hidden sm:inline">{t`Design`}</span>
            </TabsTrigger>
            <TabsTrigger value="page" className="flex-1 gap-2">
              <FileTextIcon />
              <span className="hidden sm:inline">{t`Page`}</span>
            </TabsTrigger>
            <TabsTrigger value="export" className="flex-1 gap-2">
              <ShareNetworkIcon />
              <span className="hidden sm:inline">{t`Export`}</span>
            </TabsTrigger>
            <TabsTrigger value="settings" className="flex-1 gap-2">
              <GearIcon />
              <span className="hidden sm:inline">{t`Settings`}</span>
            </TabsTrigger>
          </TabsList>
        </div>

        <div className="flex-1 overflow-hidden">
          <TabsContent value="design" className="h-full mt-0 outline-none">
            <ScrollArea orientation="vertical" className="h-full pb-16 lg:pb-0">
              <div className="space-y-8 p-6">
                <TemplateSection />
                <Separator />
                <LayoutSection />
                <Separator />
                <TypographySection />
                <Separator />
                <ThemeSection />
                <Separator />
                <CssSection />
              </div>
            </ScrollArea>
          </TabsContent>

          <TabsContent value="page" className="h-full mt-0 outline-none">
            <ScrollArea orientation="vertical" className="h-full pb-16 lg:pb-0">
              <div className="space-y-8 p-6">
                <PageSection />
                <Separator />
                <NotesSection />
              </div>
            </ScrollArea>
          </TabsContent>

          <TabsContent value="export" className="h-full mt-0 outline-none">
            <ScrollArea orientation="vertical" className="h-full pb-16 lg:pb-0">
              <div className="space-y-8 p-6">
                <SharingSection />
                <Separator />
                <ExportSection />
                <Separator />
                <StatisticsSection />
              </div>
            </ScrollArea>
          </TabsContent>

          <TabsContent value="settings" className="h-full mt-0 outline-none">
            <ScrollArea orientation="vertical" className="h-full pb-16 lg:pb-0">
              <div className="space-y-8 p-6">
                <InformationSection />
                <Separator />
                <VersionHistory />
                <Separator />
                <div className="flex items-center justify-between">
                  <span className="text-sm font-medium">{t`Dark Mode`}</span>
                  <ThemeSwitch />
                </div>
                <Separator />
                <Copyright className="text-center" />
              </div>
            </ScrollArea>
          </TabsContent>
        </div>
      </Tabs>
    </div>
  );
};
